import React from "react";
import MobileLayout from "../../Shared/MobileLayout";
import MobileNotice from "../../Shared/MobileNotice";
import OriginalComponentImpl from "../../../Components/Main/MonasheeDeals/MDTechnicalAnalysis";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const MDTechnicalAnalysisMobile: React.FC<Props> = (props) => {
  return (
    <MobileLayout title="MDTechnicalAnalysis">
      <MobileNotice page="MDTechnicalAnalysis" />
      <OriginalComponent {...props} />
    </MobileLayout>
  );
};

export default MDTechnicalAnalysisMobile;